import { useInfiniteQuery } from '@tanstack/react-query';
import { getArticles } from 'services/offerings';

/**
 * Fetch press articles for an offering.
 *
 * `enabled` lets the caller defer the fetch — used by `BuilderPressSection`
 * via `useInViewSticky` to skip the press-articles network call when the
 * section is below the fold (most page loads). Defaults to `true` so
 * existing callers (`BuilderClassicSectionNav`, etc.) are unchanged.
 */
const useGetArticles = (offeringId, { enabled = true } = {}) => {
  return useInfiniteQuery({
    queryKey: ['articles', offeringId],
    queryFn: ({ pageParam = 0 }) =>
      getArticles({
        offeringId,
        pageParam,
      }),
    getNextPageParam: (lastPage) => {
      const { pageNumber, totalPages } = lastPage;

      return pageNumber < totalPages - 1 ? pageNumber + 1 : undefined;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!offeringId && enabled,
  });
};

export default useGetArticles;
